module.exports = __webpack_public_path__ + "img/wood.16359fef.png";